import {RouterView} from '../RouterView'
const Public = _ => import(/* webpackChunkName: "js/split/Public", webpackPreload: true */ '@/components/views/panel/Certificate/Home');
const PublicDashboard = _ => import(/* webpackChunkName: "js/split/PublicDashboard", webpackPreload: true */ '@/components/views/panel/Certificate/partials/PublicDashboard');
const NotFound = _ => import(/* webpackChunkName: "js/split/NotFound", webpackPreload: true */ '@/components/views/panel/partials/NotFound');

export default {
    path: '/certificate',
    component: PublicDashboard,
    meta:{
        auth: false
    },
    children: [
        {
            path: ':id',
            props: true,
            component: Public,
            meta:{
                auth: false
            }
        },
        {
            path: '*',
            component: NotFound,
            meta:{
                auth: false
            }
        }

    ]
}
